module.exports = __webpack_public_path__ + "static/media/calendar.ef7ee279.svg";